var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import { TituloCardCinza } from './TituloCardCinza';
import { ShowContent } from '../../../components/ShowContent';
import { GridView } from './GridView';
import { dadosImv } from './FormFieldsView';
export var DadosImovelView = function (_a) {
    //region Dados Imóvel
    var _b;
    var dados = _a.dados, setActiveStep = _a.setActiveStep, tipoRequerimento = _a.tipoRequerimento;
    var dadosImvCbck = useCallback(function () {
        return dadosImv(tipoRequerimento, dados);
    }, [tipoRequerimento, dados]);
    //endregion
    var isNoKey = useCallback(function (obj) {
        var _a;
        return ((_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }, []);
    return (_jsx(TituloCardCinza, __assign({ titulo: "Dados do Im\u00F3vel", onClick: function () { return setActiveStep === null || setActiveStep === void 0 ? void 0 : setActiveStep(1); } }, { children: _jsx(Grid, __assign({ container: true, spacing: 2, justifyContent: "initial" }, { children: (_b = dadosImvCbck()) === null || _b === void 0 ? void 0 : _b.map(function (option, index) { return (_jsx(ShowContent, __assign({ show: !isNoKey(option) }, { children: _jsx(GridView, { index: index, option: option }, "grid_field_".concat(index === null || index === void 0 ? void 0 : index.toString())) }), "field-".concat(index === null || index === void 0 ? void 0 : index.toString()))); }) })) })));
};
